import { useEffect, useState } from "react";

export const useComponentsManager = (customerSites: any[], selectedSite: string) => {
    const [presentComponents, setPresentComponents] = useState<any>([]);

    useEffect(() => {
        if (customerSites && customerSites.length > 0 && selectedSite) {
            const site = customerSites.find((site) => site.name === selectedSite);
            if (site) {
                let presentComponentsLocal = site.preferences?.present_components;
                if (presentComponentsLocal) {
                    // Remove duplicates
                    presentComponentsLocal = Array.from(new Set(presentComponentsLocal));
                }
                setPresentComponents(presentComponentsLocal);
            }
        } else if (!selectedSite) {
            setPresentComponents([]);
        }
    }, [customerSites, selectedSite]);

    return { presentComponents };
};
